import { Text } from 'foundations-components/components/Text';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getPropertyDisplayName } from '../../utils/dealPropertyUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ForecastTypeDescription = ({
  forecastType,
  properties,
  isBold = true
}) => /*#__PURE__*/_jsx(Text, {
  typography: "detail-100",
  marginBlock: "100",
  children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: isBold ? 'forecastType.description' : 'forecastType.descriptionPlain',
    options: {
      dateProperty: getPropertyDisplayName(properties, forecastType === null || forecastType === void 0 ? void 0 : forecastType.dateProperty),
      amountProperty: getPropertyDisplayName(properties, forecastType === null || forecastType === void 0 ? void 0 : forecastType.amountProperty)
    }
  })
});
export default ForecastTypeDescription;